module.exports = __webpack_public_path__ + "static/media/vn.010b0c4c.svg";